import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAudits } from '../services/api';

export default function AuditHistory() {
  const [audits, setAudits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAudits().then(res => setAudits(res.data.audits || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center h-64"><p className="text-gray-500">Loading...</p></div>;
  }

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Audit History</h1>
          <p className="text-gray-500">{audits.length} total audits</p>
        </div>
        <Link to="/upload"
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium text-sm">
          New Audit
        </Link>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50 text-left text-sm text-gray-500 font-medium">
              <th className="px-5 py-3">Document</th>
              <th className="px-5 py-3">Patient</th>
              <th className="px-5 py-3">Agency</th>
              <th className="px-5 py-3">Date</th>
              <th className="px-5 py-3">Status</th>
              <th className="px-5 py-3 text-center">Score</th>
              <th className="px-5 py-3 text-center">Findings</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {audits.map(audit => (
              <tr key={audit.id} className="hover:bg-gray-50">
                <td className="px-5 py-4">
                  <Link to={`/audits/${audit.id}`} className="text-blue-600 hover:underline font-medium text-sm">
                    {audit.original_filename}
                  </Link>
                </td>
                <td className="px-5 py-4 text-sm">
                  <p className="text-slate-700">{audit.patient_full_name || '—'}</p>
                  {audit.patient_reference && (
                    <p className="text-xs text-gray-400">{audit.patient_reference}</p>
                  )}
                </td>
                <td className="px-5 py-4 text-sm text-gray-600">{audit.client_agency_name || '—'}</td>
                <td className="px-5 py-4 text-sm text-gray-500">{new Date(audit.created_at).toLocaleDateString()}</td>
                <td className="px-5 py-4">
                  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                    audit.status === 'completed' ? 'bg-green-100 text-green-700' :
                    audit.status === 'processing' ? 'bg-blue-100 text-blue-700' :
                    'bg-red-100 text-red-700'
                  }`}>{audit.status}</span>
                </td>
                <td className="px-5 py-4 text-center">
                  {audit.compliance_score != null ? (
                    <span className={`text-xl font-bold ${
                      audit.compliance_score >= 80 ? 'text-green-600' :
                      audit.compliance_score >= 60 ? 'text-yellow-600' : 'text-red-600'
                    }`}>{audit.compliance_score}</span>
                  ) : '—'}
                </td>
                <td className="px-5 py-4 text-center text-sm">
                  {audit.status === 'completed' ? (
                    <div className="flex justify-center space-x-1">
                      {audit.critical_count > 0 && <span className="bg-red-100 text-red-700 px-1.5 py-0.5 rounded text-xs">{audit.critical_count}C</span>}
                      {audit.warning_count > 0 && <span className="bg-yellow-100 text-yellow-700 px-1.5 py-0.5 rounded text-xs">{audit.warning_count}W</span>}
                      {audit.info_count > 0 && <span className="bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded text-xs">{audit.info_count}I</span>}
                    </div>
                  ) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {audits.length === 0 && (
          <div className="p-12 text-center text-gray-400">No audits yet</div>
        )}
      </div>
    </div>
  );
}
